import React, { useState } from 'react';
import { toast } from 'react-toastify';
import api from '../../../api'
import { Box, Avatar, Button, Text, Heading, Flex, AlertDialog, Spinner, TextField } from '@radix-ui/themes';
import UserAvatar from '../../common/UserAvatar';
import { useSelector } from 'react-redux';

const LinkGuardian = () => {
    const [guardianCode, setGuardianCode] = useState('');
    const [guardianInfo, setGuardianInfo] = useState(null);
    const [loading, setLoading] = useState(false);
    // const [confirmation, setConfirmation] = useState(false);
    const [isConfirmLinkOpen, setIsConfirmLinkOpen] = useState(false);
    const account = useSelector(state => state.account);

    const student = useSelector(state => state.studentAccount)

    const handleGuardianCodeChange = (e) => {
        setGuardianCode(e.target.value);
    };

    const fetchGuardianInfo = async () => {
        setLoading(true);
        try {
            const response = await api.post('/guardians/get-info', {
                guardian_code: guardianCode,
            });

            console.log('guardian info::', response.data.guardian)
            setGuardianInfo(response.data.guardian); // Store guardian info
            setLoading(false);
            setIsConfirmLinkOpen(true)
        } catch (error) {
            setLoading(false);
            if (error.response) {
                toast.error(error.response.data.error || 'Error fetching guardian info');
            }
        }
    };

    const handleConfirmation = async () => {
        if (!guardianCode) {
            toast.error('Please enter a guardian code before proceeding.');
            return;
        }

        setLoading(true);
        try {
            console.log('student::', student)
            console.log('guardian code::', guardianCode)
            console.log('student id::', studentId)
            const response = await api.post('/students/link-guardian', {
                guardian_code: guardianCode,
                student_id: student.details.id,
            });

            toast.success(response.data.message); // Show success message
        } catch (error) {
            console.log('error::', error)
            if (error.response) {
                toast.error(error.response.data.message || 'Error linking guardian');
            }
        } finally {
            setLoading(false)
            setIsConfirmLinkOpen(false)
        }
    };

    return (
        <Flex direction="column" gap="4" align="start" width="100%" style={{flex: 1}}>

            <Heading size="2" mt="4" align="start">Link Guardian</Heading>

            <TextField.Root
                type="text"
                value={guardianCode}
                onChange={handleGuardianCodeChange}
                placeholder="Enter Guardian Code"
                style={{width: '100%'}}
            />

            <Button onClick={fetchGuardianInfo} disabled={loading} type="submit" >
                {loading ? (
                    <Flex gap="2">
                        <Spinner size="1" />
                        Loading...
                    </Flex>
                ) : (
                    'Link Guardian'
                )}
            </Button>


            <AlertDialog.Root open={isConfirmLinkOpen} onOpenChange={setIsConfirmLinkOpen}>
                <AlertDialog.Content className="p-4 rounded shadow-lg w-1/3 mx-auto">
                    <AlertDialog.Title>Confirm Guardian</AlertDialog.Title>
                    <AlertDialog.Description>
                        <Flex direction="row" gap="2" align="center">
                            <UserAvatar user={guardianInfo?.user} size="4" />
                            <Box>
                                <Text>{guardianInfo?.user?.firstname} {guardianInfo?.user?.lastname}</Text>
                            </Box>
                        </Flex>
                        Are you sure you want to add "{guardianInfo?.user?.firstname} {guardianInfo?.user?.lastname}" as your guardian?
                    </AlertDialog.Description>
                    <div className="flex justify-end gap-4 mt-4">
                        <Button className='cursor-pointer' variant="soft" onClick={() => setIsConfirmLinkOpen(false)}>
                            Cancel
                        </Button>
                        <Button className='cursor-pointer' variant="solid" color="green" onClick={handleConfirmation}>
                            Link Guardian
                        </Button>
                    </div>
                </AlertDialog.Content>
            </AlertDialog.Root>
        </Flex>
    );
};

export default LinkGuardian;
